import type {BioIconProps} from '../../icons/common-types'
import {FlagIconByLocale} from '../../icons/flag-icons-by-locale'

export default function GharKeBestPicksLogo({locale, ...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold text-white tablet:gap-1 tablet:text-base">
      <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <path
          opacity="0.4"
          d="M24.2869 19.5893L7.72695 19.5952C5.51362 19.596 4.17966 17.8498 4.76558 15.7162L7.6951 4.94185C8.02799 3.70173 9.3743 2.67459 10.6543 2.67414L21.3476 2.67035C22.6276 2.6699 23.9747 3.69609 24.3084 4.93597L27.2456 15.7083C27.833 17.8414 26.5003 19.5885 24.2869 19.5893Z"
          fill="white"
        />
        <path
          d="M22.3436 28.3367C22.3438 28.8833 21.8906 29.3368 21.3439 29.337L10.6773 29.3408C10.1306 29.341 9.67712 28.8878 9.67692 28.3411C9.67673 27.7945 10.1299 27.341 10.6766 27.3408L15.0099 27.3393L15.0072 19.5926L17.0072 19.5919L17.0099 27.3386L21.3432 27.337C21.8899 27.3368 22.3434 27.79 22.3436 28.3367Z"
          fill="white"
        />
      </svg>
      <span>Ghar Ke Best Picks</span>
      <FlagIconByLocale
        locale={locale}
        className="absolute -right-6 -top-2 size-7 shrink-0 -rotate-12 tablet:-right-4 tablet:-top-1 tablet:size-5"
      />
    </div>
  )
}
